module.exports = __webpack_public_path__ + "img/logo.8b04017d.png";